import { Card, CardContent, IconButton, Tooltip, Typography, ClickAwayListener } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { useState } from "react";

type Props = {
    label: string;
    value: string | number;
    tooltip?: string;
};

const StatCard: React.FC<Props> = ({ label, value, tooltip }) => {
    const [open, setOpen] = useState(false);

    const handleToggle = () => {
        setOpen((prev) => !prev);
    };

    const handleClose = () => {
        setOpen(false);
    };

    return (
        <Card
            className="stat-card"
            elevation={0}
            sx={{
                height: "100%",
                borderRadius: 2,
                border: "1px solid",
                borderColor: "divider",
                boxShadow: "0 4px 12px rgba(0,0,0,0.06)",
                transition: "all .2s ease",
                "&:hover": {
                    boxShadow: "0 8px 24px rgba(0,0,0,0.12)",
                    transform: "translateY(-2px)",
                },
            }}
        >
            <CardContent
                sx={{
                    position: "relative",
                    pr: 4, // espacio para el icono
                }}
            >
                {/* ICONO INFO */}
                {tooltip && (
                    <ClickAwayListener onClickAway={handleClose}>
                        <Tooltip
                            title={tooltip}
                            arrow
                            open={open}
                            onClose={handleClose}
                            disableHoverListener
                            disableFocusListener
                            disableTouchListener
                            placement="top"
                        >
                            <IconButton
                                size="small"
                                onClick={handleToggle}
                                sx={{
                                    position: "absolute",
                                    top: 5,
                                    right: 5,
                                    opacity: 0.5,
                                    width: "25px",
                                    "&:hover": { opacity: 1 },
                                }}
                            >
                                <InfoOutlinedIcon fontSize="inherit" />
                            </IconButton>
                        </Tooltip>
                    </ClickAwayListener>
                )}

                {/* CONTENIDO */}
                <Typography
                    variant="overline"
                    color="text.secondary"
                    sx={{ display: "block" }}
                >
                    {label}
                </Typography>

                <Typography variant="h5" sx={{ fontWeight: 600, mt: 0.5 }}>
                    {value}
                </Typography>
            </CardContent>
        </Card>
    );
};

export default StatCard;
